import * as actionTypes from './actionTypes'

const initialState = {
    message: {
    },
    status: ''
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_FIELD:
            return updateField(state, action.name, action.value);
        case actionTypes.SUBMIT:
            return {...state, status: action.status};
        default:
            return {...state}
    }
}

const updateField = (state, name, value) => {
    const m = { ...state.message }
    m[name] = value;
    return { ...state, message: m }
}

export default reducer;